import React, { Component } from 'react';
import EnergyGeneration from './EnergyGeneration';
import PowerChart from './PowerChart';
import { SERVER_URL } from './ServerConfig'
import queryString from 'query-string';

class EnergyDetails extends Component {

    constructor(props) {
        super(props);

        let params = queryString.parse(this.props.location.search);
        this.state = {
            renderState: 'energy',
            station: {},
            isReady: false,
            params: params
        }
    }

    componentDidMount() {
        this.fetchStation();
    }

    fetchStation() {
        //let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        let stationId = this.state.params.station;
        fetch(SERVER_URL + '/v1/stations/' + stationId, {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data && data.success) {
                    let station = data.content;
                    this.setState({ isReady: true, station: station });
                }
            });
    }


    getMainContent() {
        if (!this.state.isReady) {
            return (
                <div>
                </div>);
        }
        return (<EnergyGeneration user={this.props.user} station={this.state.station} />);
    }

    changeRenderState(renderState) {
        this.setState({
            renderState: renderState
        });
    }

    render() {
        return (
            <div className="content-wrapper">
                <section className="content">
                    <div className="col-12">
                        {this.getMainContent()}
                    </div>
                </section>
            </div >
        )
    }
}

export default EnergyDetails;